import { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext();

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const toast = useCallback(({ type, message, duration = 5000, action }) => {
    const id = Date.now() + Math.random();
    const newToast = { id, type, message, duration, action };

    setToasts(prev => [...prev, newToast]);

    if (duration > 0) {
      setTimeout(() => {
        setToasts(prev => prev.filter(t => t.id !== id));
      }, duration);
    }
  }, []);

  const success = useCallback((message, options) => {
    toast({ type: 'success', message, ...options });
  }, [toast]);

  const error = useCallback((message, options) => {
    toast({ type: 'error', message, ...options });
  }, [toast]);

  const info = useCallback((message, options) => {
    toast({ type: 'info', message, ...options });
  }, [toast]);

  const warning = useCallback((message, options) => {
    toast({ type: 'warning', message, ...options });
  }, [toast]);

  const remove = useCallback((id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  }, []);

  return (
    <ToastContext.Provider value={{ toasts, success, error, info, warning, remove }}>
      {children}
    </ToastContext.Provider>
  );
}

export function useToast() {
  const context = useContext(ToastContext);
  return context;
}
